module.exports = "/work-site/img/deviceType.4a4d973a.png";